<template>
  <base-modal
    :is-visible="isModalVisible"
    :is-deletable="true"
    @hideModal="hideModal()"
    @archiveItem="archiveItem()"
    @editItem="editItem()"
    @deleteItem="deleteItem()"
  >
    <template #header>
      <span v-if="item && item.contactType === 1">{{$t('views.excmrelation.show.title')}}</span>
      <span v-else-if="item && item.contactType === 2">{{$t('views.userdata.show.mobilePhone')}}</span>
    </template>
    <template #body>
      <div v-if="!item">
        <Loader></Loader>
      </div>
      <div v-else>
        <b-row>
          <b-col>
            <p><b>{{$t('views.excmrelation.show.name')}}:</b> {{ item.title }}</p>
            <p v-if="item.description"><b>{{$t('views.excmrelation.show.description')}}:</b> {{ item.description }}</p>
            <p><b>{{$t('views.excmrelation.show.dateFrom')}}:</b> {{ $moment(item.dateFrom).format('YYYY-MM-DD HH:mm') }}</p>
            <p><b>{{$t('views.excmrelation.show.dateTo')}}:</b> {{ $moment(item.dateTo).format('YYYY-MM-DD HH:mm') }}</p>
            <p v-if="item.userData && routeName !== 'FirmShow'">
              <b v-if="item.userData.isCompany === 0">{{$t('views.exsborder.list.client')}}:</b>
              <b v-else>{{$t('views.excmrelation.show.userData')}}:</b>
              <router-link v-if="item.userData.isCompany === 0" :to="{ name: 'UserDataShow', params: { id: item.userData['@id'] }}">
                {{ item.userData.firmname1 || item.userData.fullName }}
              </router-link>
              <router-link v-else :to="{ name: 'FirmShow', params: { id: item.userData['@id'] }}">
                {{ item.userData.firmname1 || item.userData.fullName }}
              </router-link>
            </p>
            <p v-else-if="item.userData">
              <b>{{$t('views.excmrelation.show.userData')}}:</b>
              {{ item.userData.firmname1 || item.userData.fullName }}
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <h6>{{$t('views.excmrelation.show.relationUserData')}}:</h6>
          </b-col>
          <b-col cols="12" v-for="(relationUserDataItem, relationUserDataIndex) in item.relationUserData" v-bind:key="'relationUserDataItem-' + relationUserDataIndex">
            <b-row>
              <b-col sm="12" lg="1">
                <h5 class="text-center">#{{ relationUserDataIndex + 1 }}</h5>
              </b-col>
              <b-col sm="12" lg="8">
                <p class="mb-0 mt-1">{{ relationUserDataItem.userData.name }} {{ relationUserDataItem.userData.surname }}</p>
              </b-col>
              <b-col cols="12" v-if="item.relationUserData.length > (relationUserDataIndex + 1)">
                <hr class="mt-1 mb-1">
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import getIdFromLink from '@/utils/getIdFromLink'
import BaseModal from '@/components/BaseComponents/BaseModal'

export default {
  name: 'ShowRelationsModal',
  components: {
    Loader,
    BaseModal
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    iri: {
      type: String,
      required: true
    }
  },
  created () {
    this.retrieve(this.iri)
    this.routeName = this.$route.name
  },
  watch: {
    'isModalVisible' (val) {
      if (val === false) {
        this.reset()
      }
    }
  },
  computed: {
    isModalVisible () {
      return this.showModal
    },
    ...mapGetters({
      deleteError: 'excmrelation/del/error',
      error: 'excmrelation/show/error',
      isLoading: 'excmrelation/show/isLoading',
      item: 'excmrelation/show/retrieved'
    })
  },
  methods: {
    editItem () {
      this.$router.push({ name: 'EXCMRelationUpdate', params: { id: this.item['@id'] } })
    },
    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_relations/' + getIdFromLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.$emit('refetchRelations')
              this.hideModal()
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },
    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.$emit('refetchRelations')
        this.del(this.item).then(() => this.hideModal())
        this.$Swal({
          title: this.$t('notifications.deletedTitle'),
          type: 'success'
        })
      }, dismiss => {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          this.$Swal({
            title: this.$t('notifications.deleteCancel'),
            type: 'error'
          })
        }
      })
    },
    hideModal () {
      this.reset()
      this.$emit('hideModal')
    },
    ...mapActions({
      del: 'excmrelation/del/del',
      reset: 'excmrelation/show/reset',
      retrieve: 'excmrelation/show/retrieve'
    })
  }
}
</script>
